export const actionTypePrefix = '@@DEVIATIONS';

//# sourceMappingURL=constants.js.map